import { useMemo } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

// project-imports
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";
import IconButton from "components/@extended/IconButton";
import useConfig from "hooks/useConfig";
import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import { DRAWER_SLOT_WIDTH, MINI_DRAWER_SLOT_WIDTH } from "config";
import { headerAppBarSx, headerIconButtonSx, V2 } from "./headerV2Tokens";
import "./headerV2.css";

/** Remix RiMenuUnfoldLine — open sidebar */
function MenuUnfoldIcon({ size = 22, color = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden
    >
      <path d="M21 17.9995V19.9995H3V17.9995H21ZM17.4038 3.90332L22 8.49951L17.4038 13.0957L15.9896 11.6815L19.1716 8.49951L15.9896 5.31753L17.4038 3.90332ZM12 10.9995V12.9995H3V10.9995H12ZM12 3.99951V5.99951H3V3.99951H12Z" />
    </svg>
  );
}

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const theme = useTheme();

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const headerContent = useMemo(() => <HeaderContent />, []);

  const mainHeader = (
    <Toolbar
      className="header-v2"
      sx={{
        px: { xs: 2, sm: 3, lg: 3 },
        minHeight: { xs: 64, sm: 68 },
        gap: { xs: 1, sm: 1.5 },
      }}
    >
      {/* Mobile only — temporary drawer has no visible chrome when closed */}
      {downLG && (
        <IconButton
          aria-label="Ouvrir le menu"
          onClick={() => handlerDrawerOpen(true)}
          edge="start"
          color="secondary"
          variant="text"
          size="large"
          sx={{
            ...headerIconButtonSx(false),
            ml: { xs: 0, lg: -0.5 },
          }}
        >
          <MenuUnfoldIcon size={24} color={V2.ink} />
        </IconButton>
      )}

      {headerContent}
    </Toolbar>
  );

  const appBar = {
    position: "fixed",
    elevation: 0,
    sx: {
      ...headerAppBarSx,
      width: {
        xs: "100%",
        lg: drawerOpen
          ? `calc(100% - ${DRAWER_SLOT_WIDTH}px)`
          : `calc(100% - ${MINI_DRAWER_SLOT_WIDTH}px)`,
      },
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
